import React, {Component} from 'react';
import ContentPanel from '../components/ContentPanel/ContentPanel';
import Skeleton from '../components/Skeleton/Skeleton';
import withRouter from "react-router/es/withRouter";
import connect from "react-redux/es/connect/connect";
import Breadcrumbs from "../components/Breadcrumbs/Breadcrumbs";
import {REQUEST_TRAINING_VIDEOS_DATA} from "../actions/trainingVideosActions";
import ContentRenderer from "../components/ContentRenderer/ContentRenderer";
import Modal from '@material-ui/core/Modal';

const mapStateToProps = state => {
  return {
    trainingVideosData: state.trainingVideosData
  }
};

const mapDispatchToProps = dispatch => ({
  getTrainingVideosData: () => dispatch({type: REQUEST_TRAINING_VIDEOS_DATA})
});

class TrainingVideos extends Component {
  
  state = {
    openVideo: "",
  };
  
  handleOpen = (id) => {
    this.setState({ openVideo: id });
  };
  
  handleClose = () => {
    this.setState({ openVideo: "" });
  };
  
  componentDidMount() {
    if (!this.props.trainingVideosData.trainingVideos) {
      this.props.getTrainingVideosData();
    }
  };
  
  getYouTubeIdFromUrl = (url) => {
    if (!url) {
      return null
    }
    const regexp = /^(https?:\/\/)?((www\.)?(youtube(-nocookie)?|youtube.googleapis)\.com.*(v\/|v=|vi=|vi\/|e\/|embed\/|user\/.*\/u\/\d+\/)|youtu\.be\/)([_0-9a-z-]+)/mgi;
    const parsedUrl = regexp.exec(url);
    return parsedUrl ? parsedUrl[7] : null;
  };
  
  getTrainingVideosView = () => {
    
    return this.props.trainingVideosData.trainingVideos
      .map((item, index) => {
        
        const youtubeVideoId = this.getYouTubeIdFromUrl(item.link.value) ? this.getYouTubeIdFromUrl(item.link.value) : null;
        
        return (
          <div key={youtubeVideoId} className="fg__col-lg-6 fg__col-md-6 fg__col-sm-12">
            <div className="content-container content-container--bordered background-white">
              <div className="two-three-rows__image-container two-three-rows__image-container--bordered">
                <img src={youtubeVideoId ? `https://img.youtube.com/vi/${youtubeVideoId}/0.jpg` : "./assets/image-placeholder.png"} alt="" className="cover-image"/>
              </div>
              <div className="two-three-rows__card-text two-three-rows__card-text--bordered">
                <h2 className="two-three-rows__item-title">{item.title}</h2>
                <ContentRenderer
                  contentType={item.content.type}
                  value={item.content.value}
                />
                <p className="training-video-link mtm pts" onClick={() => {this.handleOpen(youtubeVideoId)}}>View Video</p>
                <Modal
                  aria-labelledby="simple-modal-title"
                  aria-describedby="simple-modal-description"
                  open={this.state.openVideo === youtubeVideoId}
                  onClose={this.handleClose}
                >
                  <div className="training-videos-iframe-container">
                    <div className="training-videos-iframe-wrapper">
                      <iframe className="training-videos-iframe" allowFullScreen="allowFullScreen" frameBorder="0" title={youtubeVideoId} src={`https://www.youtube.com/embed/${youtubeVideoId}`}></iframe>
                    </div>
                  </div>
                </Modal>
              </div>
            </div>
          </div>
        )
      })
  };
  
  render() {
    return (
      <div className="wrapper">
        <Breadcrumbs/>
        <ContentPanel
          skeleton={<Skeleton type="LONG_CONTENT_PAGE"/>}
          errorTemplate={<Skeleton type="LONG_CONTENT_PAGE_ERROR"/>}
          templateUrl="./content/home/page-components/text-block/training-videos-heading.html"
        />
        <div className="cards-list__cards-block-container">
          <div className="fg fg--box-wrapper">
            <div className="fg__col-lg-8 fg__col-md-12 fg__col-sm-12">
              <div className="fg fg--box-wrapper">
                {this.props.trainingVideosData.trainingVideos ? this.getTrainingVideosView() : <Skeleton type="LONG_CONTENT_PAGE"/>}
              </div>
            </div>
            <div className="fg__col-lg-4 fg__col-md-12 fg__col-sm-12">
              <ContentPanel
                skeleton={<Skeleton type="CONTENT_PANEL"/>}
                errorTemplate={<Skeleton type="CONTENT_PANEL_ERROR"/>}
                templateUrl="./content/home/page-components/text-block/training-videos-body-1.html"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TrainingVideos));



// WEBPACK FOOTER //
// ./src/pages/TrainingVideos.js